/* eslint-disable react/no-array-index-key */
import COLORS from '@lib/constants/colors';
import React, { ReactNode } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  width: 100%;
  overflow-x: auto;

  table {
    width: 100%;
    position: relative;
    display: table;
    border-spacing: 0px;
    border-collapse: collapse;
  }

  thead {
    display: table-header-group;
  }

  tbody {
    display: table-row-group;
    border-color: inherit;
    max-height: 350px;
    overflow-y: scroll;
  }

  tbody::before {
    content: ' ';
    height: 5px;
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
    width: 100%;
    position: absolute;
    background: ${COLORS.pink};
  }

  tr {
    vertical-align: middle;
    display: table-row;
    outline: 0px;
  }

  tr:nth-child(2n) {
    background-color: rgb(248, 249, 250);
  }

  td {
    vertical-align: middle;
    display: table-cell;
    padding: 16px;
    font-size: 0.875rem;
    text-align: left;
    color: rgb(20, 29, 43);
    border: 0px;
    line-height: 1.43;
  }

  th {
    font-weight: bold;
    line-height: 1.5rem;
    text-align: left;
    color: rgb(20, 29, 43);
    border: 0px;
    display: table-cell;
    padding: 16px;
    font-size: 0.875rem;
  }

  td p,
  th p {
    font-size: inherit;
    margin: 0;
  }

  table.scroll {
    width: auto;

    thead tr,
    tbody tr {
      display: table;
      width: 100%;
      table-layout: fixed;
    }

    tbody {
      display: block;
      max-height: 350px;
      overflow-y: scroll;
    }
  }
`;

type Foo = { text: ReactNode };

const DefaultTable = ({
  heads = [],
  rows,
  scroll = false,
}: {
  heads?: ({ text?: ReactNode } | ReactNode)[];
  rows: ({ text?: ReactNode } | ReactNode)[][];
  scroll?: boolean;
}) => (
  <Wrapper>
    <table className={scroll ? 'scroll' : ''}>
      <thead>
        <tr>
          {heads.map((item, index) => (
            <th key={index}>
              {(item as Foo)?.text ? (item as Foo).text : item}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, index) => (
          <tr key={index}>
            {row.map((item, index2) => (
              <td key={index2}>
                {(item as Foo)?.text ? (item as Foo).text : item}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </Wrapper>
);

export default DefaultTable;
